<script setup lang="ts">
import { ref, watch } from "vue";
const props = defineProps<{
        fieldName: string
        fields: number
        specialGapsAfter?: array
    }>();
const data = ref([]),
    firstInputEl = ref(null),
    emit = defineEmits(['update:modelValue', 'update:validateValue']);

watch(
    () => data,
    (newVal) => {
        if (
            newVal.value != "" &&
            newVal.value.length === props.fields &&
            !newVal.value.includes("")
        ) {
            emit("update:modelValue", newVal.value.join(""));
            emit("update:validateValue", {value: newVal.value.join(""), field_name: props.fieldName});
        } else {
            emit("update:modelValue", null);
        }
    },
    { deep: true }
);

const handleOtpInput = (e: any) => {
    if (e.data && e.target.nextElementSibling) {
        e.target.nextElementSibling.focus();
    } else if (e.data == null && e.target.previousElementSibling) {
        e.target.previousElementSibling.focus();
    }
};

const handlePaste = (e: any) => {
    const pasteData = e.clipboardData.getData('text');
    let nextEl = firstInputEl.value ? firstInputEl.value[0]?.nextElementSibling : null;
    for (let i = 1; i < pasteData.length; i++) {
        if (nextEl) {
            data.value[i] = pasteData[i];
            nextEl = nextEl.nextElementSibling;
        }
    }
};
</script>

<template>
    <div class="otp w-full flex flex-wrap justify-start gap-1" @input="handleOtpInput">
        <template v-for="field in fields" :key="field">
            <input v-model="data[field - 1]"
                   ref="firstInputEl"
                   maxlength="1"
                   class="w-6 h-10 text-center"
                   :class="{ 'mr-2': specialGapsAfter.includes(field) }"
                   @paste="field === 1 && handlePaste($event)" />
        </template>
    </div>
</template>

<style scoped>
input {
    background: var(--color-kozel-white);
    font-size: 0.8rem;
}

input::placeholder, label, input, .regulations-items, .message-box, .error-label {
    font-family: 'ApexSerif', 'serif';
    font-weight: 700;
}

input::placeholder {
    color: var(--color-kozel-sandy);
}
</style>